











/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { EEntities } from '@/types'

/* API */

export default Vue.extend({
  name: 'AddWorkflowJobItem',

  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
    },
  },

  data() {
    return {
      ColorAssistant,
      TextAssistant,
    }
  },

  computed: {
    btnColor(): string {
      return ColorAssistant.getEntityColor(this.entityType)
    },
  },
})
